<p-card class="sticky-nav">
  <div class="flex items-left gap-2">
    <p-select
      placeholder="Select Content Unit"
      [attr.data-test]="'template-cu-nav-select'"
      [formControl]="navControl"
      [options]="navService.sectionOptions()"
      (onChange)="navService.goToSection($event.value)"
    />

    <button pButton
            type="button"
            severity="secondary"
            iconOnly
            [attr.data-test]="'template-cu-nav-up'"
            [disabled]="navService.currentIndex() === 0"
            [outlined]="true"
            (click)="navService.goToPreviousSection()"
    >
      <i class="pi pi-chevron-up"></i>
    </button>

    <button pButton
            type="button"
            severity="secondary"
            iconOnly
            [attr.data-test]="'template-cu-nav-down'"
            [disabled]="navService.currentIndex() === (formArray().length - 1)"
            [outlined]="true"
            (click)="navService.goToNextSection()"
    >
      <i class="pi pi-chevron-down"></i>
    </button>
  </div>
</p-card>

<div class="flex flex-col gap-4 pt-4">
  @for (unitGroup of formArray().controls; track unitGroup.value?.contentUnit?.uuid; let i = $index) {
    <div #unitEl
         class="scroll-target"
         [attr.data-index]="i"
         [attr.data-test]="'content-unit-' + unitGroup.value?.contentUnit?.uuid"
    >
      <p-panel [collapsed]="!showDetails()"
               [toggleable]="true"
      >
        <ng-template #header>
          <div class="flex-1">
            <h3 class="font-bold text-lg m-0">{{ unitGroup.value?.contentUnit?.title }}</h3>
            <p class="text-gray-600 text-sm mb-3">{{ unitGroup.value?.contentUnit?.description }}</p>
          </div>
        </ng-template>

        <div class="flex justify-between items-start">
          <div class="flex-1">

            <div class="content-preview mb-3 p-3 bg-gray-50 border border-gray-200 rounded font-mono text-sm whitespace-pre-wrap">
              <code [innerHTML]="getHighlightedContent(unitGroup.value?.contentUnit?.content)"></code>
            </div>

            <button pButton
                    type="button"
                    severity="secondary"
                    [attr.data-test]="'template-cu-add-condition'"
                    [disabled]="viewMode()"
                    [outlined]="true"
            >
              Add Condition
            </button>

            <div class="flex flex-wrap gap-2 mt-3">
              @for (tag of unitGroup.value?.contentUnit?.tags; track tag) {
                <p-tag
                  [value]="tag"
                />
              }
            </div>
          </div>
          <div class="flex flex-col items-center p-1 ml-4">
            <button pButton
                    type="button"
                    iconOnly
                    [disabled]="i === 0 || viewMode()"
                    [outlined]="true"
                    (click)="move(i, -1)"
            >
              <i class="pi pi-chevron-up"></i>
            </button>

            <input
              #idxInput
              aria-label="Index Input"
              class="my-1 w-10 text-center px-1 py-1 bg-white border border-gray-200 rounded font-mono font-bold focus:outline-none focus:ring-1 focus:ring-primary"
              id="idxInput"
              type="number"
              [disabled]="viewMode()"
              [value]="i + 1"
              (blur)="moveTo(i, idxInput.value)"
              (keydown.enter)="moveTo(i, idxInput.value)"
            />

            <button pButton
                    type="button"
                    iconOnly
                    [disabled]="i === (formArray().length - 1)  || viewMode()"
                    [outlined]="true"
                    (click)="move(i, 1)"
            >
              <i class="pi pi-chevron-down"></i>
            </button>

            <button pButton
                    type="button"
                    class="mt-4"
                    iconOnly
                    [disabled]="viewMode()"
                    [outlined]="true"
                    (click)="deleteCu(i)"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
      </p-panel>
    </div>
  }
</div>
